/* eslint-disable camelcase */
import { makeAutoObservable, set, toJS } from 'mobx'
import FormData from './FormData'
import uuid from 'react-uuid'

/**
 * Form Entry is equipment for this form
 */
class FormEntry {
  id = 0
  uuid = 0
  clients_addresses_equipment_id = 0
  event_id = 0
  form_id = 0

  internal_data = ''
  is_valid = false
  forms_datas = {}

  get readonly () {
    return this._readonly
  }

  constructor (data, readonly = false) {
    makeAutoObservable(this)
    if (data) {
      if (data.forms_datas) {
        for (const formData of data.forms_datas) {
          this.forms_datas[formData.key] = new FormData(formData)
        }
        delete data.forms_datas
      }
      set(this, data)
    }
    this._readonly = readonly
  }

  updateValue (field, value, isFixed = false) {
    if (this.forms_datas[field]) {
      this.forms_datas[field].value = value
      this.forms_datas[field].errorMessage = ''
    } else {
      this.forms_datas[field] = new FormData({
        key: field,
        value: value,
        is_fixed: isFixed
      })
    }
  }

  hasValue (field) {
    return this.forms_datas[field] && !!this.forms_datas[field].value
  }

  getValue (field, isFixed = false, defaultValue = '', isRequired = false) {
    if (!this.forms_datas[field]) {
      this.forms_datas[field] = new FormData({
        key: field,
        value: defaultValue || '',
        is_fixed: isFixed
      })
    }
    return this.forms_datas[field].value
  }

  setError (field, errorMessage) {
    if (this.forms_datas[field]) {
      this.forms_datas[field].errorMessage = errorMessage
    } else {
      this.forms_datas[field] = new FormData({
        key: field,
        value: null,
        errorMessage
      })
    }
  }

  getError (field) {
    if (this.forms_datas[field] && this.forms_datas[field].errorMessage) {
      return this.forms_datas[field].errorMessage
    }
    return undefined
  }

  generateUUID () {
    if (!this.uuid) {
      this.uuid = uuid()
    }
  }

  /**
   *
   * @returns {object}
   */
  toObject () {
    const data = toJS(this)
    if (data.id === 0) {
      delete data.id
      delete data._readonly
    }
    data.forms_datas = Object.values(this.forms_datas)
      .filter(formData => {
      // filter before sending to the server. If nothing was added don't send it
        return !(!formData.id && !formData.value && !formData.is_fixed)
      })
      // convert model object to server object ( remove unwanted fields )
      .map(formData => formData.toObject())
    return data
  }
}

export default FormEntry
